import { useFieldArray, useFormContext } from "react-hook-form";

import { Paper, Stack, Typography } from "@mui/material";

import { formatNumber } from "../../../shared";
import { CustomTable } from "../../../ui";

export const LensProductItem = () => {
  const { control } = useFormContext();

  const { fields: purchaseOrderProductVariants } = useFieldArray({
    control,
    name: "purchaseOrderProductVariants",
  });

  const columns = [
    { field: "side", headerName: "Sisi" },
    { field: "sku", headerName: "SKU" },
    {
      field: "variant",
      headerName: "Varian",
      renderCell: ({ name, note }) => {
        // Get axis from note
        let axis = "-";
        try {
          const parsed = JSON.parse(note || "{}");
          axis = parsed.axis || "-";
        } catch {
          // Ignore JSON parse errors
        }

        // Parse prescription parts: {sph}/{cyl}/{add?}/{side?}
        const prescriptionParts = name
          ?.substring(name.lastIndexOf(" ") + 1)
          .split("/");
        const sph = prescriptionParts?.[0] || "-";
        const cyl = prescriptionParts?.[1] || "-";
        const add = prescriptionParts?.[2] || "0"; // Use "0" if null
        // Ignore prescriptionParts[3] (side indicator)

        // Build prescription
        const prescription = `${sph}/${cyl}/${axis}/${add}`;

        return prescription;
      },
    },
    {
      field: "variantNote",
      headerName: "PD/Prism",
      renderCell: ({ note }) => {
        let pd = "-",
          prism = "-";

        try {
          const parsed = JSON.parse(note || "{}");
          pd = parsed.pd || "-";
          prism = parsed.prism || "-";
        } catch {
          // Ignore JSON parse errors
        }

        // Build prescription format: {sideLabel}: {pd}/{prism}
        const prescription = `${pd}/${prism}`;

        return prescription;
      },
    },
    {
      field: "costPerUnit",
      headerName: "Harga",
      align: "right",
      renderCell: ({ costPerUnit }) => formatNumber(costPerUnit),
    },
  ];

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography>
            {purchaseOrderProductVariants[0]?.product.name}
          </Typography>
          <Typography>
            Add On:{" "}
            {(() => {
              try {
                const note = purchaseOrderProductVariants[0]?.note || "{}";
                const parsed = JSON.parse(note);
                return parsed.addOn ? (
                  <Typography component="span" sx={{
                    fontWeight: "500"
                  }}>
                    {parsed.addOn}
                  </Typography>
                ) : (
                  "-"
                );
              } catch {
                return "-";
              }
            })()}
          </Typography>
        </Stack>
        <CustomTable
          columns={columns}
          rows={purchaseOrderProductVariants}
          keyField="side"
        />
      </Stack>
    </Paper>
  );
};
